export default __webpack_public_path__ + "static/2-5489a76a864d444d2a40b281857b4a29.gif";